import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import StackKit from "../../kit/stack";

// حل مشکل آیکون‌های پیش‌فرض leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export interface Location {
  name: string;
  lat: number | string;
  lng: number;
}

interface MapViewProps {
  locations: Location[] | undefined;
  height?: string;
  width?: string;
}

function FitBounds({ bounds }: { bounds: L.LatLngBoundsExpression }) {
  const map = useMap();

  useEffect(() => {
    if (bounds && Array.isArray(bounds) && bounds.length > 0) {
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, [map, bounds]);

  return null;
}

const MapView: React.FC<MapViewProps> = ({
  locations,
  height = "500px",
  width = "100%",
}) => {
  if (!locations || locations.length === 0) {
    return (
      <div
        style={{
          height,
          width,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        موقعیتی برای نمایش وجود ندارد.
      </div>
    );
  }

  const bounds: L.LatLngBoundsExpression = locations.map(
    (loc) => [Number(loc.lat), Number(loc.lng)] as L.LatLngTuple
  );

  return (
    <MapContainer
      style={{ height, width }}
      center={[Number(locations[0].lat), Number(locations[0].lng)]}
      zoom={13}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {locations.map((loc, index) => (
        <Marker
          key={`marker-${index}`}
          position={[Number(loc.lat), Number(loc.lng)]}
        >
          <Popup>{loc.name}</Popup>
        </Marker>
      ))}

      <FitBounds bounds={bounds} />
    </MapContainer>
  );
};

export default MapView;
